module.exports = __webpack_public_path__ + "img/applepay.3da54d02.svg";